import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/store/user'
import Login from '../views/Login.vue'
import AdminLayout from '../views/Layout.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: AdminLayout,
    children: [
      {
        path: 'cases',
        name: 'Cases',
        component: () => import('@/views/Cases.vue')
      },
      {
        path: 'bikes',
        name: 'Bikes',
        component: () => import('@/views/Bikes.vue')
      },
      {
        path: 'accounts',
        name: 'Accounts',
        component: () => import('@/views/Accounts.vue')
      },
      {
        path: 'logs',
        name: 'Logs',
        component: () => import('@/views/Logs.vue')
      },
      {
        path: 'files',
        name: 'Files',
        component: () => import('@/views/Files.vue')
      },
      {
        path: 'cases/:id',
        name: 'CaseDetail',
        component: () => import('@/views/CaseDetail.vue')
      },
      {
        path: '',
        redirect: '/cases'
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  const token = userStore.token

  if (to.path === '/login') {
    if (token) {
      next('/')
    } else {
      next()
    }
  } else {
    if (token) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
